import { useEffect, useState } from "react";
import { CompositeChart } from "@mantine/charts";
import { useTranslation } from "react-i18next";
import { CHART_ACCENT } from "@constants/resultColors";

export default function ContrastSensitivityChart(props: any) {
  const normals: any = [
    { grating: 0, Normals: [1, 4] },
    { grating: 1, Normals: [0, 3] },
    { grating: 2, Normals: [1, 4] },
    { grating: 3, Normals: [4, 7] },
  ];

  const { t } = useTranslation();

  const [data, setData] = useState(normals);

  const yTicks = [0.33, 0.5, 1, 2, 5, 10, 20, 50];
  const xTicks = [3, 6, 12, 18];

  useEffect(() => {
    const vals = xTicks.map((x, ind) => {
      return {
        grating: ind,
        normals: normals.find((n) => n.grating === ind).Normals,
      };
    });

    if (props.data) {
      vals.forEach((v: any) => {
        const contrast = props.data.find((d) => xTicks.indexOf(d.grating) === v.grating);
        if (contrast) {
          v.contrast = yTicks.indexOf(
            yTicks.reduce((prev, curr) =>
              Math.abs(curr - contrast.contrast * 100) < Math.abs(prev - contrast.contrast * 100)
                ? curr
                : prev,
            ),
          );
        }
      });

      setData(vals);
      console.log("contrastSensitivityStatus", data);
    }
  }, [props.data]);

  return (
    <CompositeChart
      p={"lg"}
      h={400}
      data={data}
      dataKey="grating"
      withLegend
      withTooltip={false}
      connectNulls={false}
      legendProps={{ verticalAlign: "bottom" }}
      series={[
        { name: "contrast", label: t("contrastValues"), color: CHART_ACCENT.target, type: "line" },
        { name: "normals", label: t("ageNormals"), color: CHART_ACCENT.expected, type: "area" },
      ]}
      yAxisProps={{
        label: {
          value: t("contrastPercent"),
          position: "insideLeft",
          angle: -90,
          offset: 15,
        },
        reversed: true,
        ticks: yTicks.map((_, i) => i),
        tickFormatter: (value) => yTicks[value].toString(),
        interval: 0,
      }}
      xAxisProps={{
        label: t("gratings"),
        ticks: xTicks.map((_, i) => i),
        tickFormatter: (value) => xTicks[value].toString(),
        interval: 0,
        domain: [0, 3],
      }}
      curveType="linear"
      areaProps={{ dot: false, stroke: "0" }}
      tickLine="xy"
      gridAxis="xy"
    />
  );
}
